import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import {
    SearchTextBox,
    StyledInput,
    StyledSearchInputContainer,
} from "app/pages/sales-intelligence/common-components/SearchTextBox";

export const StyledSearchTextBox = styled(SearchTextBox)`
    ${StyledSearchInputContainer}, ${StyledInput} {
        background-color: ${colorsPalettes.carbon["0"]};
    }
`;
